import React from 'react'
import fetch from 'node-fetch'
import { ApolloProvider as Provider } from 'react-apollo'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloClient } from 'apollo-client'
import { ApolloLink } from 'apollo-link'
import { setContext } from 'apollo-link-context'
import { onError } from 'apollo-link-error'
import { toast } from 'react-toastify'
import { createUploadLink } from 'apollo-upload-client'
import { useStaticQuery, graphql } from "gatsby"

if (process.env.NODE_ENV  === 'production') {
const data = useStaticQuery(
  graphql`
    query {
      site {
        siteMetadata {
          apiUrl
        }
      }
    }
  `
)
var apiUrl = data.site.siteMetadata.apiUrl
} else {
var apiUrl = 'https://www.api.dev.moishlem.ru/graphql'
}

const httpLink = createUploadLink({
  fetch,
  uri: apiUrl
})

const errorLink = onError(({ networkError, graphQLErrors }) => {
  if (graphQLErrors) {
    toast.error(
      'There was an error while trying to connect to the server, please try again',
      {
        position: toast.POSITION.TOP_CENTER,
      }
    )
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    )
  }
  if (networkError) {
    toast.error(`[Network error]: ${networkError}`, {
      position: toast.POSITION.TOP_CENTER,
    })
    console.log(`[Network err]: Message: ${networkError}`)
  }
})

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('token')
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  }
})
const link = ApolloLink.from([errorLink, authLink.concat(httpLink)])

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link,
})

export default ({ children }) => {
  return <Provider client={client}>{children}</Provider>
}